import axios from 'axios';

export default axios.create({
    headers : {
        "content-type" : "application/json"
    }
})